import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
	standalone: true,
	name: 'safeHtml'
})
export class SafeHtmlPipe implements PipeTransform {

	constructor(protected _santizer: DomSanitizer){}
	/**
	 * Transform the html pipe in safe html
	 * @param value: HTML value
	 * @param type: HTML/resourceUrl
	 * @returns return santizer value
	 */
	public transform(value: string, type: string='html'): SafeHtml | SafeResourceUrl {
		switch (type) {
			case 'html':
				return this._santizer.bypassSecurityTrustHtml(value);
			case 'resourceUrl':
				return this._santizer.bypassSecurityTrustResourceUrl(value);
			default:
				throw new Error(`Unable to bypass security for invalid type: ${type}`);
		}
	}
}